export default __webpack_public_path__ + "static/media/badgePack.4d5dadd1.svg";